import React from "react";
import { Fade } from "react-awesome-reveal";

export default function Description() {
  return (
    <div className="flex-1 space-y-6">
      {/* *********************************************************************************************************** */}
      {/* animation */}
      <Fade cascade damping={0.1}>
        <h3 className="text-2xl">Ali's Portfolio</h3>
        <p>Thank you for visiting my personal portfolio website. Connect with me over socials.</p>
        <p>Keep Rising. Connect with me over live chat!</p>
      </Fade>
      {/* *********************************************************************************************************** */}
    </div>
  );
}
